class ExitIntentPopup {
  constructor(snippet) {
    this.snippet = snippet;
    this.dialog = snippet.querySelector('.exit-intent__dialog');
    this.form = snippet.querySelector('#ExitIntentForm');
    this.emailInput = snippet.querySelector('#ExitIntentEmail');
    this.codeMessage = snippet.querySelector('.exit-intent__code');
    this.closeButtons = snippet.querySelectorAll('[data-exit-intent-close]');
    this.visibleClass = 'is-visible';
    this.hasShown = false;

    const { delay, triggerExit, triggerTimer, disableMobile } = snippet.dataset;
    const parsedDelay = parseInt(delay, 10);
    this.delay = Number.isNaN(parsedDelay) ? 30000 : Math.max(parsedDelay, 0);
    this.enableExitIntent = triggerExit === 'true';
    this.enableTimer = triggerTimer === 'true';
    this.disableMobile = disableMobile === 'true';

    this.boundMouseLeave = this.handleMouseLeave.bind(this);
    this.boundKeyDown = this.handleKeyDown.bind(this);

    if (this.enableExitIntent) {
      document.addEventListener('mouseleave', this.boundMouseLeave);
    }

    document.addEventListener('keydown', this.boundKeyDown);

    this.boundTimer = null;
    if (this.enableTimer && this.delay >= 0) {
      this.boundTimer = setTimeout(() => this.trigger('timer'), this.delay);
    }

    this.closeButtons.forEach((btn) => btn.addEventListener('click', () => this.hide()));

    if (this.form) {
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        if (this.emailInput && !this.emailInput.validity.valid) {
          this.emailInput.reportValidity();
          return;
        }
        this.showCode();
      });
    }
  }

  handleMouseLeave(event) {
    if (!this.enableExitIntent) return;
    if (event.clientY <= 0) {
      this.trigger('exit-intent');
    }
  }

  handleKeyDown(event) {
    if (event.key === 'Escape') {
      this.hide();
    }
  }

  trigger(source) {
    if (this.hasShown) return;
    if (this.disableMobile && window.innerWidth < 750) return;

    this.hasShown = true;
    this.show();

    if (this.enableExitIntent) {
      document.removeEventListener('mouseleave', this.boundMouseLeave);
    }

    if (this.boundTimer) {
      clearTimeout(this.boundTimer);
    }
  }

  show() {
    this.snippet.classList.add(this.visibleClass);
    this.snippet.setAttribute('aria-hidden', 'false');
    if (this.emailInput) {
      this.emailInput.focus({ preventScroll: true });
    }
  }

  hide() {
    this.snippet.classList.remove(this.visibleClass);
    this.snippet.setAttribute('aria-hidden', 'true');
  }

  showCode() {
    if (this.codeMessage) {
      this.codeMessage.hidden = false;
    }
    if (this.form) {
      this.form.hidden = true;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const template = document.getElementById('ExitIntentTemplate');
  if (!template) return;
  const html = template.innerHTML.trim();
  if (!html) return;
  document.body.insertAdjacentHTML('beforeend', html);
  const popup = document.getElementById('ExitIntent');
  if (popup) new ExitIntentPopup(popup);
});

